import { render, staticRenderFns } from "./CreditScoreController.vue?vue&type=template&id=489fd72a&scoped=true&"
import script from "./CreditScoreController.vue?vue&type=script&lang=ts&"
export * from "./CreditScoreController.vue?vue&type=script&lang=ts&"
import style0 from "./credit-score-controller.scss?vue&type=style&index=0&id=489fd72a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489fd72a",
  null
  
)

export default component.exports